import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import { useEditCameraStore } from "./editCameraStore/editCameraStore";
import { TableHeadComponent } from "../../common/TableHead";

export const SlicingTab = () => {
  const { cameraStreams, cameraStreamsObject, showSlicingWarningMessage } =
    useEditCameraStore();

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHeadComponent
          titlesArray={["Stream", "Stream Products", "Slicing", "Max Slices"]}
        />
        <TableBody>
          {cameraStreams?.map((stream: any, index: number) => (
            <TableRow key={stream.id}>
              <TableCell
                align="left"
                sx={{ fontFamily: "Mulish", width: "25%" }}
              >
                {stream.name}
              </TableCell>
              <TableCell
                align="left"
                sx={{ fontFamily: "Mulish", width: "25%" }}
              >
                {stream.product}
              </TableCell>
              <TableCell
                align="left"
                sx={{ fontFamily: "Mulish", width: "25%" }}
              >
                {stream.name === "production_gun" &&
                cameraStreamsObject[index]?.slice ? (
                  <Tooltip
                    title="Slicing is required and enabled automatically for gun detection (already included in the cost)."
                    placement="top"
                  >
                    <span>
                      <Switch
                        checked={cameraStreamsObject[index]?.slice}
                        color="warning"
                        disabled={true}
                      />
                    </span>
                  </Tooltip>
                ) : (
                  <Switch
                    checked={cameraStreamsObject[index]?.slice}
                    color="warning"
                    disabled={true}
                  />
                )}
              </TableCell>
              <TableCell
                align="left"
                sx={{ fontFamily: "Mulish", width: "25%" }}
              >
                {cameraStreamsObject[index]?.slice
                  ? cameraStreamsObject[index]?.max_slices
                  : ""}
                {cameraStreamsObject[index]?.slice &&
                  cameraStreamsObject[index]?.max_slices &&
                  (cameraStreamsObject[index]?.max_slices ?? 0) <= 4 &&
                  showSlicingWarningMessage && (
                    <div>
                      <div className="text-red-500 text-[12px]">
                        Your site/camera may require a higher number
                      </div>
                      <div className="text-red-500 text-[12px]">
                        of slices. Please contact Support to inquire.
                      </div>
                    </div>
                  )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
